import Entity from './entity'

export default class Transport extends Entity<number>{
    code:string;
    transportType:string;
    transportTypeName:string;
    statusCode : string;
    statusName: string;
    lastModificationTime: Date;
    lastModifierUserId: number;
    lastModifierUserName: string;
}